import React from 'react'
import { inject, observer } from 'mobx-react'

import Modal from '../../../generic/Modal'
import EditCompaniesForm from './EditCompaniesForm'

const EditCompaniesModal = inject('configCompaniesStore')(observer(props => {
  const { configCompaniesStore } = props
  const { editModalIsActive, isUpdating } = configCompaniesStore.state
  const modalOptions = [{
    text: 'Salvar',
    type: 'button',
    isLoading: isUpdating,
    onClick: () => configCompaniesStore.updateCompany()
  }]
  return (
    <Modal
      isActive={editModalIsActive}
      onClose={() => configCompaniesStore.closeEditModal()}
      title='Editar empresa'
      options={modalOptions}
    >
      <EditCompaniesForm />
    </Modal>
  )
}))

export default EditCompaniesModal



// WEBPACK FOOTER //
// ./src/components/dashboard/config/companies/EditCompaniesModal.js